export interface IContactNote {
	readonly creationTimestamp: number;
	readonly taskId: string;
	readonly note: string;
}

export class ContactNote implements IContactNote {
	private _creationTimestamp: number;
	private _taskId: string;
	private _note: string;

	constructor(taskId: string, note: string, creationTimestamp: number) {
		this._creationTimestamp = creationTimestamp;
		this._taskId = taskId;
		this._note = note;
	}

	get creationTimestamp(): number {
		return this._creationTimestamp;
	}

	get taskId(): string {
		return this._taskId;
	}

	get note(): string {
		return this._note;
	}
}
